export enum roleActionTypes {
  SET_ROLES = 'SET_ROLES',
  SET_ROLE_ID_FOR_DELETE = 'SET_ROLE_ID_FOR_DELETE',
  SET_CURRENT_ROLE_PERMISSIONS = 'SET_CURRENT_ROLE_PERMISSIONS',
  SET_CURRENT_ROLE_PAGE_FEATURE_PERMISSIONS = 'SET_CURRENT_ROLE_PAGE_FEATURE_PERMISSIONS',
  SET_CURRENT_ROLE_PAGE_FEATURE_ACTION_PERMISSIONS = 'SET_CURRENT_ROLE_PAGE_FEATURE_ACTION_PERMISSIONS',
  SET_CURRENT_ROLE_PAGE_GROUP_FEATURE_ACTION_PERMISSIONS = 'SET_CURRENT_ROLE_PAGE_GROUP_FEATURE_ACTION_PERMISSIONS',
  SET_CURRENT_ROLE_PERMISSIONS_IS_SAVING = 'SET_CURRENT_ROLE_PERMISSIONS_IS_SAVING',
  DELETING_ROLE_LOADING = 'DELETING_ROLE_LOADING',
}
